import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Plantel } from '../models/Plantel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlantelesService {
  API_URI = environment.uri_api;
  //'http://localhost:3000';

  constructor(private http: HttpClient) { }

  getPlanteles(){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.get(`${this.API_URI}/plantel`,{headers:httpHeaders});
  }

  getPlantelesPlantel(idplantel: number){
    // console.log("Valor en getPlantelesPlantel antes del back "+idplantel);
      var t=localStorage.getItem('token');

      const httpHeaders=new HttpHeaders({
        'content-type':'application/json',
        'Authorization': ''+t
      });

      return this.http.get(`${this.API_URI}/plantel/plantel/${idplantel}`,{headers:httpHeaders});
    }



  getfiltrarPlantel(nombreplantel:string){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.get(`${this.API_URI}/plantel/planteles/${nombreplantel}`,{headers:httpHeaders});
  }

  getPlantel(id: number){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.get(`${this.API_URI}/Plantel/${id}`,{headers:httpHeaders});

  }

  getPlantelByid(id: number){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.get(`${this.API_URI}/Plantel/${id}`,{headers:httpHeaders});

  }

//
getIdPlantelxx(plantel:string){

  var t=localStorage.getItem('token');

  const httpHeaders=new HttpHeaders({
    'content-type':'application/json',
    'Authorization': ''+t
  });

  return this.http.get(`${this.API_URI}/PlantelId/${plantel}`,{headers:httpHeaders});

}

//



  createPlantel (plantel: Plantel, mailusu:any){

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.post(`${this.API_URI}/plantel/${mailusu}`, plantel,{headers:httpHeaders});
  }

  updatePlantel (id: number, mailusu:any, plantel: Plantel) {

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.put(`${this.API_URI}/plantel/${id}/${mailusu}`, plantel,{headers:httpHeaders});
  }
  deletePlantel (id: number, mailusu:any) {

    var t=localStorage.getItem('token');

    const httpHeaders=new HttpHeaders({
      'content-type':'application/json',
      'Authorization': ''+t
    });

    return this.http.delete(`${this.API_URI}/plantel/${id}/${mailusu}`,{headers:httpHeaders});
  }
}
